import { useAccessBase } from '@/shared/modules/auth';
import { useCallback } from 'react';
export const useAccess = () => {
    const { isAdmin, userClaims, userCrossDocks, userStockLocations } = useAccessBase();
    const hasAccessTo = useCallback(({ claims, groups }) => {
        if (isAdmin)
            return true;
        if ((groups?.includes('crossdocking') && userCrossDocks.length > 0) ||
            (groups?.includes('stock') && userStockLocations.length > 0) ||
            (claims && userClaims.some((userClaim) => claims.includes(userClaim)))) {
            return true;
        }
        return false;
    }, [isAdmin, userClaims, userCrossDocks.length, userStockLocations.length]);
    return {
        isAdmin,
        userClaims,
        userCrossDocks,
        userStockLocations,
        userHasAccessTo: hasAccessTo,
    };
};
